
/** Estados possívels da conexão */
export enum SignalRConnectionState{
    Connecting = 0,
    Connected = 1,
    Reconnecting = 2,
    Disconnected = 4,
}

export const getHumanFriendlySignalRConnectionState = (state: SignalRConnectionState) => {
    switch (state) {
        case SignalRConnectionState.Connecting:
             return "Connecting";
        case SignalRConnectionState.Connected:
            return "Connected";
        case SignalRConnectionState.Reconnecting:
            return "Reconnecting";
        case SignalRConnectionState.Disconnected:
            return "Disconnected";
        default:
            return "Undefined";
    }
}
